import { useQuery } from "@tanstack/react-query";
import { OrganizationService, UserProfile as OrganizationUserProfile } from "@/features/Organization/services/organizationService";

/**
 * Hook para obter as informações do perfil e organização do usuário atual
 */
export const useOrganization = () => {
  const query = useQuery<OrganizationUserProfile>({
    queryKey: ['current-user-profile'],
    queryFn: async () => {
      try {
        const result = await OrganizationService.getCurrentUserProfile();
        console.log('[useOrganization] ✅ Perfil do usuário carregado com sucesso:', result);
        return result;
      } catch (error) {
        console.error('[useOrganization] ❌ Erro ao carregar perfil:', error);
        throw error;
      }
    },
    // Configurar para não mostrar erros no console quando o usuário não está autenticado
    retry: (failureCount: number, error: unknown) => {
      // Não tentar novamente para erros de autenticação
      if (error instanceof Error && error.message === 'Usuário não autenticado') {
        return false;
      }
      // Para outros erros, tentar novamente até 3 vezes
      return failureCount < 3;
    },
  });
  
  return query;
};

/**
 * Hook para obter os detalhes de uma organização pelo ID
 * @param organizationId ID da organização
 */
export const useOrganizationDetails = (organizationId: string | undefined) => {
  return useQuery({
    queryKey: ['organization', organizationId],
    queryFn: () => organizationId ? OrganizationService.getOrganizationById(organizationId) : null,
    enabled: !!organizationId,
  });
};

/**
 * Hook para obter todos os usuários de uma organização
 * @param organizationId ID da organização
 */
export const useOrganizationUsers = (organizationId: string | undefined) => {
  return useQuery({
    queryKey: ['organization-users', organizationId],
    queryFn: () => organizationId ? OrganizationService.getUsersByOrganization(organizationId) : null,
    enabled: !!organizationId,
  });
};
